module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27676",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.4199",
      "atom": "static-1.4685",
      "conversations-async-data": "static-2.7271",
      "conversations-error-reporting": "static-1.8488",
      "conversations-infrastructure": "static-1.8510",
      "conversations-internal-pub-sub": "static-1.15571",
      "conversations-internal-schema": "static-1.12224",
      "conversations-message-history": "static-1.11362",
      "conversations-test-sdk": "static-1.10005",
      "conversations-visitor-experience-components": "static-1.21039",
      "head-dlb": "static-1.4465",
      "hs-promise-utils": "static-1.5097",
      "hs-test-utils": "static-1.7503",
      "hubspot-dlb": "static-2.1744",
      "HubStyleTokens": "static-2.11026",
      "I18n": "static-7.1506",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2523",
      "jasmine-runner": "static-1.5984",
      "quartz": "static-1.6373",
      "react-dlb": "static-1.67",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.3963",
      "StyleGuideUI": "static-3.481",
      "transmute": "static-2.77",
      "urlinator": "static-1.4136",
      "usage-tracker": "static-1.6942",
      "usage-tracker-core": "static-1.6792",
      "usage-tracker-public": "static-1.6753",
      "viral-links-lib": "static-1.6530",
      "visitor-ui-component-library": "static-1.5736",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4335",
      "conversations-prop-types": "static-1.6946",
      "conversations-visibility-tools": "static-1.5309",
      "conversations-visitor-message-history": "static-1.19776",
      "cssUtils": "static-1.659",
      "enviro": "static-4.345",
      "flux-actions": "static-1.293",
      "foundations-components": "static-1.7109",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3768",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9233",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.319",
      "raven": "static-3.5386",
      "react": "static-7.151",
      "react-aria": "static-1.57",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.16232",
      "react-utils": "static-2.4961",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7711",
      "signup-constants": "static-1.17924",
      "styled-components": "static-2.64",
      "usage-tracker-multi": "static-1.5356",
      "visitor-ui-component-library-icons": "static-1.5547",
      "hs-promise-rejection-tracking": "static-1.4918",
      "raven-hubspot": "static-1.5693",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3045",
      "moment": "static-3.26",
      "quartz-config": "static-1.151",
      "quartz-core": "static-1.5592",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4395",
      "foundations-theming": "static-1.3933",
      "UIComponents": "static-3.7973",
      "cv-backend-services": "static-1.1401",
      "immutable-less": "static-1.4114",
      "conversations-skeleton-state": "static-1.6861",
      "crm-events-viz-core": "static-1.31838",
      "customer-agent-discovery-components-lib": "static-1.1872",
      "icons": "static-2.601",
      "react-input-autosize": "static-2.17",
      "react-router-dom": "static-5.26",
      "rpc-client-utils": "static-1.4213",
      "tanstack-virtual": "static-1.23",
      "ui-images": "static-2.1019",
      "HeadJS": "static-2.659",
      "framer-motion": "static-1.61",
      "hs-test-utils-bend-plugin": "static-1.2614",
      "msw": "static-1.39",
      "testing-library": "static-1.143",
      "i18n-data": "static-1.214",
      "moment-timezone": "static-5.76",
      "jasmine": "static-4.3832",
      "history": "static-4.47",
      "signup-ui-url-generator": "static-2.7617",
      "HubStyle": "static-2.11334",
      "sassPrefix": "static-1.148",
      "bend-plugin-foundations-components": "static-1.3378",
      "floating-ui": "static-1.49",
      "foundations-theming-specialty": "static-1.1649",
      "hs-story-utils": "static-1.8923",
      "react-virtualized": "static-2.90",
      "tanstack-table": "static-1.23",
      "trellis-assets": "static-1.813",
      "ui-fonts": "static-1.337",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3551",
      "usage-tracker-anonymous": "static-1.5359",
      "bender-build-tools": "static-1.2706",
      "dispatcher": "static-1.128",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.738",
      "hubspotter-http": "static-1.4254",
      "mobile-manifest-mixins": "static-1.432",
      "quartz-auth": "static-1.48",
      "quartz-head": "static-1.38",
      "quartz-i18n": "static-1.48",
      "quartz-test": "static-1.48",
      "bend-plugin-foundations-theming": "static-1.2416",
      "foundations-theming-base": "static-1.2918",
      "stylex": "static-1.25",
      "ts-schema": "static-1.3728",
      "apollo-stack-hubspot": "static-3.69",
      "avatar-components": "static-1.2070",
      "content-assistance-lib": "static-1.7182",
      "crm-component-utils": "static-1.37966",
      "crm-display-components": "static-1.23716",
      "crm-fe-perf": "static-1.22488",
      "crm-links": "static-1.5752",
      "crm-message-bus": "static-1.41811",
      "crm-search-service-types": "static-1.815",
      "crm-source-interpretation-lib": "static-1.4826",
      "customer-data-communicator": "static-1.44344",
      "customer-data-email": "static-1.17241",
      "customer-data-filters-ui": "static-1.38142",
      "customer-data-objects": "static-1.7213",
      "customer-data-objects-ui-components": "static-1.12552",
      "customer-data-properties": "static-1.50140",
      "customer-data-rte": "static-1.31938",
      "customer-data-ui-utilities": "static-1.9323",
      "data-fetching-client": "static-1.9243",
      "draft-plugins": "static-2.20870",
      "file-manager-components": "static-1.22257",
      "FileManagerCore": "static-1.37756",
      "framework-data-schema-resolvers": "static-1.6474",
      "frontend-preferences-client": "static-1.7524",
      "hubspot-apollo-client": "static-1.4386",
      "hubspot-prosemirror": "static-1.17048",
      "object-comments-thread-lib": "static-1.9587",
      "reference-resolvers-lite": "static-1.7606",
      "ui-addon-upgrades": "static-9.17266",
      "universal-associations-select": "static-1.10543",
      "ai-components-ui-library": "static-1.7758",
      "final-form": "static-1.63",
      "hub-http-shared-msw-handlers": "static-1.8963",
      "hubspotter-http-shared-msw-handlers": "static-1.8961",
      "graphql": "static-1.75",
      "superstore": "static-1.4305",
      "ui-addon-video-player": "static-1.8332",
      "ui-coaching-tips": "static-1.27369",
      "card-properties-lib": "static-1.42960",
      "crm-actions": "static-1.5770",
      "crm-cards-data": "static-1.786",
      "crm-cards-sdk": "static-1.42324",
      "customer-data-properties-shared-msw-handlers": "static-1.8290",
      "customer-data-property-utils": "static-1.7551",
      "customer-data-tracking": "static-1.6467",
      "usage-tracker-container": "static-1.6932",
      "framework-data-table": "static-2.10911",
      "location-customization-utils-lib": "static-1.7968",
      "calling-error-reporting": "static-1.30885",
      "calling-internal-common": "static-1.30879",
      "calling-usage-tracker": "static-1.6146",
      "crm_data": "static-4.90561",
      "crm_schema": "static-3.90600",
      "crm-legacy-global-containers": "static-1.23364",
      "customer-data-content": "static-1.26446",
      "draft-content-plugins": "static-1.27300",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23298",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.22997",
      "EmailSignatureEditor": "static-1.23556",
      "FileManagerLib": "static-1.37897",
      "hubspot-prosemirror-plugins": "static-1.17040",
      "integration-settings-components": "static-1.14098",
      "integrations-lib": "static-1.14759",
      "integrations-tracking-lib": "static-1.5186",
      "native-integrations-shared-strings": "static-1.7393",
      "nav-meta": "static-1.28368",
      "onboarding-scopes": "static-1.6052",
      "outreach-assistant-email-generation": "static-1.5378",
      "property-translator": "static-1.4933",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.36551",
      "react-colorpicker": "static-2.9781",
      "react-dnd-compat": "static-1.4232",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7764",
      "rich-text-lib": "static-1.19035",
      "sales-email-signature-service-client": "static-1.3445",
      "sequences-lib": "static-1.7370",
      "timezone-utils": "static-2.4748",
      "ui-addon-i18n": "static-1.10599",
      "ui-addon-iframeable": "static-1.8508",
      "ui-business-units-lib": "static-1.8515",
      "ui-gdpr-components": "static-1.9829",
      "ui-shepherd-react": "static-3.9658",
      "user-context": "static-1.4688",
      "whatsapp-sending-lib": "static-1.4371",
      "apollo-dlb": "static-3.73",
      "apollo-link-hub-http": "static-2.4261",
      "salesImages": "static-1.517",
      "customer-data-filters-ui-msw-helpers": "static-1.20576",
      "customer-data-reference-ui-components": "static-1.12631",
      "FormUrlGenerator": "static-2.4227",
      "framework-builder-read-service-client": "static-1.3563",
      "framework-data-schema-quick-fetch": "static-1.6379",
      "inbound-db-meta-service-client": "static-1.3282",
      "inbound-db-properties-service-client": "static-1.3503",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.564",
      "onboarding-tours": "static-1.15990",
      "reporting-datasets-permissions-lib": "static-1.12396",
      "SharedI18nStrings": "static-1.179",
      "ui-addon-teams": "static-1.20953",
      "calling-global-api": "static-1.63012",
      "calling-lifecycle-internal": "static-1.64394",
      "calling-lifecycle-messages": "static-1.56688",
      "commerce-products-lib": "static-1.8193",
      "conditional-properties-service-client": "static-1.3444",
      "external-options-client-types": "static-1.3664",
      "google-libphonenumber": "static-1.31",
      "inbound-db-associations-writes-service-client": "static-1.2773",
      "inbounddb-objects-service-types": "static-1.3763",
      "meetings-icalendar-utils-lib": "static-1.145",
      "multi-currency-client-types": "static-1.3293",
      "object-builder-ui-client": "static-1.47328",
      "pipeline-validation-client-types": "static-1.3505",
      "property-value-citations": "static-1.754",
      "smart-property-lib": "static-1.5119",
      "tiered-pricing": "static-1.517",
      "ui-addon-form-validation": "static-1.10566",
      "fast-json-stable-stringify": "static-1.4",
      "immerable": "static-1.3666",
      "video-components-external": "static-1.9971",
      "video-data-lib": "static-1.33629",
      "audio-components": "static-1.5349",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35408",
      "ui-universal-auth": "static-1.8415",
      "video-components": "static-1.11974",
      "video-embed": "static-1.34463",
      "batch-promise": "static-1.1139",
      "crm-pipelines-api-client-types": "static-1.3654",
      "persist-promise": "static-1.3296",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24137",
      "knowledge-content-types": "static-1.8190",
      "payment-link-components": "static-1.22408",
      "ui-addon-emoji-picker": "static-1.9452",
      "call-summary": "static-1.37703",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9109",
      "feature-store-service-types": "static-1.4140",
      "growth-monetization-service-types": "static-1.4147",
      "merchandise-lib": "static-1.251",
      "purchase-motions-components": "static-1.5108",
      "self-service-api": "static-1.9786",
      "upgrade-management-service-types": "static-1.4131",
      "chatspot-client-types": "static-1.10249",
      "chatspot-core": "static-1.19601",
      "ContentUtils": "static-1.67037",
      "copilot-toolkit": "static-1.9949",
      "growth-onboarding-feedback-components": "static-1.6100",
      "customer-data-sidebar": "static-2.44821",
      "enrichment-properties-lib": "static-1.14237",
      "customer-data-associations": "static-1.6836",
      "deal-intel-decorators": "static-1.619",
      "reporting-data": "static-1.65702",
      "ui-addon-draggable": "static-3.4357",
      "crm-record-cards-service-types": "static-1.3286",
      "crm_universal": "static-1.21388",
      "SalesContentIndexUI": "static-3.8502",
      "signup-ui-lego-core": "static-1.19934",
      "content-embed-lib": "static-1.6950",
      "data-model-builder-lib": "static-1.10925",
      "remote-ui": "static-1.58",
      "ui-components-test-utils": "static-1.5164",
      "ui-extensions-remote-renderer": "static-1.15920",
      "universal-page-editor-lib": "static-1.2596",
      "integrations-error-boundary-lib": "static-1.12174",
      "laboratory-lib": "static-3.6702",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9981",
      "rxjs": "static-5.10",
      "messaging-types-lib": "static-1.44742",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15708",
      "sequences-client-types-lib": "static-1.7227",
      "foundations-components-test-utils": "static-1.4593",
      "magpie-lib": "static-1.5173",
      "navigation-messaging": "static-1.6058",
      "getting-started-shared-tasks": "static-1.17310",
      "getting-started-shared-tasks-store": "static-1.16428",
      "onboarding-tours-utils": "static-1.56",
      "whatsapp-management-lib": "static-1.7530",
      "growth-data-modal": "static-1.4925",
      "growth-onboarding-confetti": "static-1.2617",
      "growth-onboarding-next-action-utils": "static-1.995",
      "navigation-components": "static-1.16731",
      "onboarding-tours-client": "static-1.4204",
      "ui-shepherd-tracker": "static-1.7039",
      "shared-worker-versioning": "static-1.10626",
      "calling-orchestration-shared-library": "static-1.34204",
      "products-iframe-lib": "static-1.6767",
      "products-ui-components-shared-msw-handlers": "static-1.9345",
      "breeze-intelligence-kit": "static-1.5014",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9046",
      "fsm": "static-1.3240",
      "policy-lib": "static-1.6329",
      "react-tinymce": "static-1.54048",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53174",
      "tinymce-plugins": "static-1.56288",
      "tinymce-themes": "static-1.55144",
      "content-media-composition-data-lib": "static-1.10507",
      "content-media-compositions": "static-2.14514",
      "idb-keyval": "static-1.37",
      "magpie-types": "static-1.4633",
      "media-bridge-lib": "static-1.18240",
      "content-icons-ui": "static-1.2074",
      "social-insights-client-types": "static-1.20861",
      "outpost": "static-1.3837",
      "commerce-analytics-service-client": "static-1.3183",
      "ui-addon-opt": "static-4.8003",
      "commerce-tours-lib": "static-1.5381",
      "growth-onboarding-reliability": "static-1.4699",
      "sales-checkout-service-client": "static-1.3195",
      "ai-addon-copilot-preview": "static-1.6970",
      "calling-cross-tab-library": "static-1.18850",
      "calling-lifecycle-usage-tracker": "static-1.7571",
      "wootric-nps": "static-1.6485",
      "nav-client-types": "static-1.1834",
      "purchase-motions-api": "static-1.5110",
      "trials-service-types": "static-1.3548",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4265",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2566",
      "card-payment-highlight-lib": "static-1.35968",
      "card-subscription-highlight-lib": "static-1.38336",
      "commerce-billing-lib": "static-1.17893",
      "commerce-contract-lib": "static-1.10467",
      "crm_components": "static-3.90561",
      "invoices-highlight-card-lib": "static-1.53397",
      "orders-highlight-card-lib": "static-1.20425",
      "products-highlight-card-lib": "static-1.16477",
      "project-storage": "static-1.4236",
      "quotes-highlight-card-lib": "static-1.70464",
      "usage-based-billing-components-lib": "static-1.7467",
      "deal-intel-utils": "static-1.623",
      "reporting-client-types": "static-1.2320",
      "react-flip-move": "static-1.63",
      "FireAlarmUi": "static-1.4147",
      "sales-templates-service-types-lib": "static-1.3817",
      "ui-asset-management-lib": "static-1.10423",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.9072",
      "collaboration-sidebar": "static-1.56638",
      "conditional-property-settings-modal": "static-1.11488",
      "data-model-commons-lib": "static-1.11428",
      "feedback-loader": "static-1.28410",
      "html-to-image": "static-1.47",
      "object-definition-builder-lib": "static-1.6604",
      "property-management-iframe": "static-1.11568",
      "reactflow": "static-1.54",
      "simple-data-table": "static-1.1585",
      "used-in-list-lib": "static-1.6459",
      "visual-association": "static-1.5390",
      "highcharts": "static-8.97",
      "reporting-visualizations": "static-1.57779",
      "ui-extensibility-client-types": "static-1.3572",
      "automation-platform-service-types": "static-1.2385",
      "ContentData": "static-1.67112",
      "email-portal-health-service-types": "static-1.582",
      "marketing-email-service-types": "static-1.1685",
      "reactive-lib": "static-1.289",
      "content-whatsapp-service-types": "static-1.118",
      "marketing-platform-lib": "static-1.6329",
      "short-messages-app-service-client": "static-1.3621",
      "ui-tool-access": "static-1.9692",
      "calling-orchestration-schema": "static-1.34429",
      "sales-views-client-types": "static-1.3853",
      "trellis-story-utils": "static-1.4092",
      "storybook-react": "static-1.25",
      "hub-http-contrib": "static-1.2659",
      "interframe": "static-3.4314",
      "tinymce-data": "static-1.39259",
      "ui-addon-sales-email": "static-1.4774",
      "codemirror": "static-5.88",
      "layout-dnd-components": "static-1.11664",
      "layout-dnd-utils": "static-1.10639",
      "react-codemirror": "static-1.10214",
      "ui-brand-identity-lib": "static-1.12997",
      "NamespacedHubStyle": "static-2.8726",
      "hls.js": "static-1.32",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.8682",
      "ai-settings-ui-library": "static-1.7027",
      "chirp-fetch": "static-1.1494",
      "copilot-plugins": "static-1.9922",
      "eligibility-engine-service-types": "static-1.2829",
      "commerce-shared-components-lib": "static-1.17385",
      "commerce-subscription-lib": "static-1.35913",
      "commerce-tools-ui-lib": "static-1.9331",
      "usage-tracker-session-replay": "static-1.4628",
      "utility-belt": "static-1.2054",
      "payments-enrollment-embed-lib": "static-1.21280",
      "quotes-ui-lib": "static-1.79182",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6311",
      "invoices-ui-lib": "static-1.53413",
      "commerce-products-api": "static-1.1571",
      "SafeStorage": "static-1.3907",
      "invoices-iframe-lib": "static-1.55471",
      "quotes-modal-lib": "static-1.101139",
      "reporting-ui-components": "static-2.62975",
      "subscription-experience-data-types": "static-1.14205",
      "association-translator": "static-1.2713",
      "crm-settings-header-lib": "static-1.7806",
      "settings-ui-nav": "static-2.9748",
      "chatspot-widget-iframe": "static-1.19593",
      "collaboration-sidebar-common": "static-1.1434",
      "crm-properties-common-lib": "static-1.5368",
      "ui-addon-draggable-compat": "static-2.3863",
      "property-management-common": "static-1.3855",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14456",
      "advanced-menus-lib": "static-1.11467",
      "ExportDialog": "static-6.9991",
      "ui-memberships-settings-lib": "static-1.32826",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.8964",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.12946",
      "highlight.js": "static-1.72",
      "reporting-action-components": "static-1.40156",
      "ui-addon-react-router-dom": "static-1.9149",
      "growth-onboarding-empty-states": "static-1.5092",
      "InboxConnectUtils": "static-4.13728",
      "payments-post-enroll-local-storage-lib": "static-1.4585",
      "qrcode-generator": "static-1.62",
      "amplitude-session-replay-browser": "static-1.53",
      "marketplace-ui-apps-core": "static-1.16902",
      "stripe-embedded-components": "static-1.6802",
      "products-ui-components": "static-1.38712",
      "totals-ui-components": "static-1.22418",
      "reporting-plugins": "static-1.9621",
      "reporting-reports": "static-1.65381",
      "reporting-snowflake": "static-1.54321",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14455",
      "simple-menus-lib": "static-1.15972",
      "academy-common-lib": "static-1.12406",
      "dashboard-lib": "static-1.79814",
      "share-with-third-party-component-lib": "static-1.8246",
      "developer-experience-shared-components": "static-1.9977",
      "marketplace-ui-client-types": "static-1.15775",
      "marketplace-ui-common": "static-1.18368",
      "ui-addon-integrations-directory-panel": "static-2.7587",
      "stripe-connect-js": "static-1.43",
      "commerce-permissions": "static-1.308",
      "property-description-translator": "static-1.3380",
      "commerce-totals-service-types": "static-1.3410",
      "campaign-roi-lib": "static-1.7677",
      "academy-service-client": "static-1.3256",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3496",
      "oauth-service-types": "static-1.3816",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27676",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4199",
      "atom": "/atom/static-1.4685",
      "conversations-async-data": "/conversations-async-data/static-2.7271",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8488",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8510",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15571",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12224",
      "conversations-message-history": "/conversations-message-history/static-1.11362",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10005",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.21039",
      "head-dlb": "/head-dlb/static-1.4465",
      "hs-promise-utils": "/hs-promise-utils/static-1.5097",
      "hs-test-utils": "/hs-test-utils/static-1.7503",
      "hubspot-dlb": "/hubspot-dlb/static-2.1744",
      "HubStyleTokens": "/HubStyleTokens/static-2.11026",
      "I18n": "/I18n/static-7.1506",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2523",
      "jasmine-runner": "/jasmine-runner/static-1.5984",
      "quartz": "/quartz/static-1.6373",
      "react-dlb": "/react-dlb/static-1.67",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.3963",
      "StyleGuideUI": "/StyleGuideUI/static-3.481",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.4136",
      "usage-tracker": "/usage-tracker/static-1.6942",
      "usage-tracker-core": "/usage-tracker-core/static-1.6792",
      "usage-tracker-public": "/usage-tracker-public/static-1.6753",
      "viral-links-lib": "/viral-links-lib/static-1.6530",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5736",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4335",
      "conversations-prop-types": "/conversations-prop-types/static-1.6946",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5309",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19776",
      "cssUtils": "/cssUtils/static-1.659",
      "enviro": "/enviro/static-4.345",
      "flux-actions": "/flux-actions/static-1.293",
      "foundations-components": "/foundations-components/static-1.7109",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3768",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9233",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.319",
      "raven": "/raven/static-3.5386",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.57",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.16232",
      "react-utils": "/react-utils/static-2.4961",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7711",
      "signup-constants": "/signup-constants/static-1.17924",
      "styled-components": "/styled-components/static-2.64",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5356",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5547",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
      "raven-hubspot": "/raven-hubspot/static-1.5693",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3045",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.151",
      "quartz-core": "/quartz-core/static-1.5592",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4395",
      "foundations-theming": "/foundations-theming/static-1.3933",
      "UIComponents": "/UIComponents/static-3.7973",
      "cv-backend-services": "/cv-backend-services/static-1.1401",
      "immutable-less": "/immutable-less/static-1.4114",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6861",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31838",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.1872",
      "icons": "/icons/static-2.601",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-router-dom": "/react-router-dom/static-5.26",
      "rpc-client-utils": "/rpc-client-utils/static-1.4213",
      "tanstack-virtual": "/tanstack-virtual/static-1.23",
      "ui-images": "/ui-images/static-2.1019",
      "HeadJS": "/HeadJS/static-2.659",
      "framer-motion": "/framer-motion/static-1.61",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2614",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.143",
      "i18n-data": "/i18n-data/static-1.214",
      "moment-timezone": "/moment-timezone/static-5.76",
      "jasmine": "/jasmine/static-4.3832",
      "history": "/history/static-4.47",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7617",
      "HubStyle": "/HubStyle/static-2.11334",
      "sassPrefix": "/sassPrefix/static-1.148",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3378",
      "floating-ui": "/floating-ui/static-1.49",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1649",
      "hs-story-utils": "/hs-story-utils/static-1.8923",
      "react-virtualized": "/react-virtualized/static-2.90",
      "tanstack-table": "/tanstack-table/static-1.23",
      "trellis-assets": "/trellis-assets/static-1.813",
      "ui-fonts": "/ui-fonts/static-1.337",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3551",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5359",
      "bender-build-tools": "/bender-build-tools/static-1.2706",
      "dispatcher": "/dispatcher/static-1.128",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.738",
      "hubspotter-http": "/hubspotter-http/static-1.4254",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.432",
      "quartz-auth": "/quartz-auth/static-1.48",
      "quartz-head": "/quartz-head/static-1.38",
      "quartz-i18n": "/quartz-i18n/static-1.48",
      "quartz-test": "/quartz-test/static-1.48",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2416",
      "foundations-theming-base": "/foundations-theming-base/static-1.2918",
      "stylex": "/stylex/static-1.25",
      "ts-schema": "/ts-schema/static-1.3728",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "avatar-components": "/avatar-components/static-1.2070",
      "content-assistance-lib": "/content-assistance-lib/static-1.7182",
      "crm-component-utils": "/crm-component-utils/static-1.37966",
      "crm-display-components": "/crm-display-components/static-1.23716",
      "crm-fe-perf": "/crm-fe-perf/static-1.22488",
      "crm-links": "/crm-links/static-1.5752",
      "crm-message-bus": "/crm-message-bus/static-1.41811",
      "crm-search-service-types": "/crm-search-service-types/static-1.815",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4826",
      "customer-data-communicator": "/customer-data-communicator/static-1.44344",
      "customer-data-email": "/customer-data-email/static-1.17241",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38142",
      "customer-data-objects": "/customer-data-objects/static-1.7213",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12552",
      "customer-data-properties": "/customer-data-properties/static-1.50140",
      "customer-data-rte": "/customer-data-rte/static-1.31938",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9323",
      "data-fetching-client": "/data-fetching-client/static-1.9243",
      "draft-plugins": "/draft-plugins/static-2.20870",
      "file-manager-components": "/file-manager-components/static-1.22257",
      "FileManagerCore": "/FileManagerCore/static-1.37756",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6474",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7524",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4386",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17048",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9587",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7606",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17266",
      "universal-associations-select": "/universal-associations-select/static-1.10543",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7758",
      "final-form": "/final-form/static-1.63",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8963",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8961",
      "graphql": "/graphql/static-1.75",
      "superstore": "/superstore/static-1.4305",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8332",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27369",
      "card-properties-lib": "/card-properties-lib/static-1.42960",
      "crm-actions": "/crm-actions/static-1.5770",
      "crm-cards-data": "/crm-cards-data/static-1.786",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42324",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8290",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7551",
      "customer-data-tracking": "/customer-data-tracking/static-1.6467",
      "usage-tracker-container": "/usage-tracker-container/static-1.6932",
      "framework-data-table": "/framework-data-table/static-2.10911",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7968",
      "calling-error-reporting": "/calling-error-reporting/static-1.30885",
      "calling-internal-common": "/calling-internal-common/static-1.30879",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6146",
      "crm_data": "/crm_data/static-4.90561",
      "crm_schema": "/crm_schema/static-3.90600",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23364",
      "customer-data-content": "/customer-data-content/static-1.26446",
      "draft-content-plugins": "/draft-content-plugins/static-1.27300",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23298",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.22997",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23556",
      "FileManagerLib": "/FileManagerLib/static-1.37897",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17040",
      "integration-settings-components": "/integration-settings-components/static-1.14098",
      "integrations-lib": "/integrations-lib/static-1.14759",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5186",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7393",
      "nav-meta": "/nav-meta/static-1.28368",
      "onboarding-scopes": "/onboarding-scopes/static-1.6052",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5378",
      "property-translator": "/property-translator/static-1.4933",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.36551",
      "react-colorpicker": "/react-colorpicker/static-2.9781",
      "react-dnd-compat": "/react-dnd-compat/static-1.4232",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7764",
      "rich-text-lib": "/rich-text-lib/static-1.19035",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3445",
      "sequences-lib": "/sequences-lib/static-1.7370",
      "timezone-utils": "/timezone-utils/static-2.4748",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10599",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8508",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8515",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9829",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9658",
      "user-context": "/user-context/static-1.4688",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4371",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4261",
      "salesImages": "/salesImages/static-1.517",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20576",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12631",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4227",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3563",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6379",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3282",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3503",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.564",
      "onboarding-tours": "/onboarding-tours/static-1.15990",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12396",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
      "ui-addon-teams": "/ui-addon-teams/static-1.20953",
      "calling-global-api": "/calling-global-api/static-1.63012",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64394",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56688",
      "commerce-products-lib": "/commerce-products-lib/static-1.8193",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3444",
      "external-options-client-types": "/external-options-client-types/static-1.3664",
      "google-libphonenumber": "/google-libphonenumber/static-1.31",
      "inbound-db-associations-writes-service-client": "/inbound-db-associations-writes-service-client/static-1.2773",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3763",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.145",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3293",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47328",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3505",
      "property-value-citations": "/property-value-citations/static-1.754",
      "smart-property-lib": "/smart-property-lib/static-1.5119",
      "tiered-pricing": "/tiered-pricing/static-1.517",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10566",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "immerable": "/immerable/static-1.3666",
      "video-components-external": "/video-components-external/static-1.9971",
      "video-data-lib": "/video-data-lib/static-1.33629",
      "audio-components": "/audio-components/static-1.5349",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35408",
      "ui-universal-auth": "/ui-universal-auth/static-1.8415",
      "video-components": "/video-components/static-1.11974",
      "video-embed": "/video-embed/static-1.34463",
      "batch-promise": "/batch-promise/static-1.1139",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3654",
      "persist-promise": "/persist-promise/static-1.3296",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24137",
      "knowledge-content-types": "/knowledge-content-types/static-1.8190",
      "payment-link-components": "/payment-link-components/static-1.22408",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9452",
      "call-summary": "/call-summary/static-1.37703",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9109",
      "feature-store-service-types": "/feature-store-service-types/static-1.4140",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4147",
      "merchandise-lib": "/merchandise-lib/static-1.251",
      "purchase-motions-components": "/purchase-motions-components/static-1.5108",
      "self-service-api": "/self-service-api/static-1.9786",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4131",
      "chatspot-client-types": "/chatspot-client-types/static-1.10249",
      "chatspot-core": "/chatspot-core/static-1.19601",
      "ContentUtils": "/ContentUtils/static-1.67037",
      "copilot-toolkit": "/copilot-toolkit/static-1.9949",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6100",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44821",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14237",
      "customer-data-associations": "/customer-data-associations/static-1.6836",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.619",
      "reporting-data": "/reporting-data/static-1.65702",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4357",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3286",
      "crm_universal": "/crm_universal/static-1.21388",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8502",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19934",
      "content-embed-lib": "/content-embed-lib/static-1.6950",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.10925",
      "remote-ui": "/remote-ui/static-1.58",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5164",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.15920",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2596",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12174",
      "laboratory-lib": "/laboratory-lib/static-3.6702",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9981",
      "rxjs": "/rxjs/static-5.10",
      "messaging-types-lib": "/messaging-types-lib/static-1.44742",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15708",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7227",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4593",
      "magpie-lib": "/magpie-lib/static-1.5173",
      "navigation-messaging": "/navigation-messaging/static-1.6058",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17310",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16428",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.56",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7530",
      "growth-data-modal": "/growth-data-modal/static-1.4925",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2617",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.995",
      "navigation-components": "/navigation-components/static-1.16731",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4204",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7039",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10626",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34204",
      "products-iframe-lib": "/products-iframe-lib/static-1.6767",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9345",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5014",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9046",
      "fsm": "/fsm/static-1.3240",
      "policy-lib": "/policy-lib/static-1.6329",
      "react-tinymce": "/react-tinymce/static-1.54048",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53174",
      "tinymce-plugins": "/tinymce-plugins/static-1.56288",
      "tinymce-themes": "/tinymce-themes/static-1.55144",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10507",
      "content-media-compositions": "/content-media-compositions/static-2.14514",
      "idb-keyval": "/idb-keyval/static-1.37",
      "magpie-types": "/magpie-types/static-1.4633",
      "media-bridge-lib": "/media-bridge-lib/static-1.18240",
      "content-icons-ui": "/content-icons-ui/static-1.2074",
      "social-insights-client-types": "/social-insights-client-types/static-1.20861",
      "outpost": "/outpost/static-1.3837",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3183",
      "ui-addon-opt": "/ui-addon-opt/static-4.8003",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5381",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4699",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3195",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.6970",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18850",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.7571",
      "wootric-nps": "/wootric-nps/static-1.6485",
      "nav-client-types": "/nav-client-types/static-1.1834",
      "purchase-motions-api": "/purchase-motions-api/static-1.5110",
      "trials-service-types": "/trials-service-types/static-1.3548",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4265",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2566",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.35968",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38336",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.17893",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10467",
      "crm_components": "/crm_components/static-3.90561",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53397",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20425",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16477",
      "project-storage": "/project-storage/static-1.4236",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70464",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7467",
      "deal-intel-utils": "/deal-intel-utils/static-1.623",
      "reporting-client-types": "/reporting-client-types/static-1.2320",
      "react-flip-move": "/react-flip-move/static-1.63",
      "FireAlarmUi": "/FireAlarmUi/static-1.4147",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3817",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10423",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.9072",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56638",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.11488",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11428",
      "feedback-loader": "/feedback-loader/static-1.28410",
      "html-to-image": "/html-to-image/static-1.47",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6604",
      "property-management-iframe": "/property-management-iframe/static-1.11568",
      "reactflow": "/reactflow/static-1.54",
      "simple-data-table": "/simple-data-table/static-1.1585",
      "used-in-list-lib": "/used-in-list-lib/static-1.6459",
      "visual-association": "/visual-association/static-1.5390",
      "highcharts": "/highcharts/static-8.97",
      "reporting-visualizations": "/reporting-visualizations/static-1.57779",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3572",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2385",
      "ContentData": "/ContentData/static-1.67112",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.582",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1685",
      "reactive-lib": "/reactive-lib/static-1.289",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.118",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6329",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3621",
      "ui-tool-access": "/ui-tool-access/static-1.9692",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34429",
      "sales-views-client-types": "/sales-views-client-types/static-1.3853",
      "trellis-story-utils": "/trellis-story-utils/static-1.4092",
      "storybook-react": "/storybook-react/static-1.25",
      "hub-http-contrib": "/hub-http-contrib/static-1.2659",
      "interframe": "/interframe/static-3.4314",
      "tinymce-data": "/tinymce-data/static-1.39259",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4774",
      "codemirror": "/codemirror/static-5.88",
      "layout-dnd-components": "/layout-dnd-components/static-1.11664",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10639",
      "react-codemirror": "/react-codemirror/static-1.10214",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12997",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8726",
      "hls.js": "/hls.js/static-1.32",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.8682",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7027",
      "chirp-fetch": "/chirp-fetch/static-1.1494",
      "copilot-plugins": "/copilot-plugins/static-1.9922",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2829",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17385",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35913",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9331",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4628",
      "utility-belt": "/utility-belt/static-1.2054",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21280",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79182",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6311",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53413",
      "commerce-products-api": "/commerce-products-api/static-1.1571",
      "SafeStorage": "/SafeStorage/static-1.3907",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55471",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101139",
      "reporting-ui-components": "/reporting-ui-components/static-2.62975",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14205",
      "association-translator": "/association-translator/static-1.2713",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7806",
      "settings-ui-nav": "/settings-ui-nav/static-2.9748",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19593",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1434",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5368",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3863",
      "property-management-common": "/property-management-common/static-1.3855",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14456",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11467",
      "ExportDialog": "/ExportDialog/static-6.9991",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32826",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.8964",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.12946",
      "highlight.js": "/highlight.js/static-1.72",
      "reporting-action-components": "/reporting-action-components/static-1.40156",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9149",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5092",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13728",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4585",
      "qrcode-generator": "/qrcode-generator/static-1.62",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16902",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6802",
      "products-ui-components": "/products-ui-components/static-1.38712",
      "totals-ui-components": "/totals-ui-components/static-1.22418",
      "reporting-plugins": "/reporting-plugins/static-1.9621",
      "reporting-reports": "/reporting-reports/static-1.65381",
      "reporting-snowflake": "/reporting-snowflake/static-1.54321",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14455",
      "simple-menus-lib": "/simple-menus-lib/static-1.15972",
      "academy-common-lib": "/academy-common-lib/static-1.12406",
      "dashboard-lib": "/dashboard-lib/static-1.79814",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8246",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9977",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15775",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18368",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7587",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "commerce-permissions": "/commerce-permissions/static-1.308",
      "property-description-translator": "/property-description-translator/static-1.3380",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3410",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7677",
      "academy-service-client": "/academy-service-client/static-1.3256",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3496",
      "oauth-service-types": "/oauth-service-types/static-1.3816",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};